import { useMemo } from "react";
import isEmpty from "lodash-es/isEmpty";

import useExecuteQuery from "hooks/useExecuteQuery";

import { READ_IAM_QUERY } from "graphqlQueries/auth";
import { iamTypesMapper } from "graphqlQueries/auth.map";

export default function useSignInPage() {
  const { data, loading } = useExecuteQuery(READ_IAM_QUERY, {
    dataMapper: iamTypesMapper,
  });

  const { iamTypes = [], remoteIamEnabled = false } = useMemo(() => {
    if (isEmpty(data)) return {};
    return data;
  }, [data]);

  return { iamTypes, remoteIamEnabled, loading };
}
